import { Component } from '@angular/core';

type HeroSlide = {
  id: string;
  headline: { text: string; color: 'blue' | 'red' }[][];
  subtitle: string;
  bullets: string[];
  driverLabel?: string;
  price?: string;
  priceSuffix?: string;
  ctaText?: string;
  showCta: boolean;
  caption: string;
  sceneShift: number;
  copyAlign: 'left' | 'right';
  showPartnerLogos?: boolean;
};

@Component({
  selector: 'app-content',
  standalone: true,
  templateUrl: './content.html',
  styleUrl: './content.css'
})
export class ContentComponent {
  protected isPortabilityModalOpen = false;
  private readonly whatsappUrl = 'https://wa.me/573337909090';
  protected activeHeroIndex = 0;
  protected readonly heroSlides: HeroSlide[] = [
    {
      id: 'peak-time',
      headline: [
        [{ text: 'NUNCA MAS TE QUEDES', color: 'blue' }],
        [
          { text: 'SIN DATOS ', color: 'blue' },
          { text: 'EN PLENA', color: 'red' }
        ],
        [{ text: 'HORA PICO', color: 'red' }]
      ],
      subtitle: 'Plan exclusivo para socios conductores Yango:',
      bullets: [
        '60 GB + minutos ilimitados',
        'Waze y WhatsApp sin gastar tus datos',
        'Puedes compartir el 100% de tus GB'
      ],
      driverLabel: 'Socio conductor:',
      price: '$23.400',
      priceSuffix: '/MES',
      ctaText: 'QUIERO MI PLAN EXCLUSIVO',
      showCta: true,
      caption: 'Conserva tu numero. Activacion 100% digital.',
      sceneShift: 0,
      copyAlign: 'left'
    },
    {
      id: 'no-stops',
      headline: [
        [{ text: 'TU GPS', color: 'blue' }],
        [{ text: 'NUNCA SE CAE', color: 'red' }],
        [
          { text: 'WAZE ILIMITADO ', color: 'red' },
          { text: 'PARA TRABAJAR', color: 'blue' }
        ],
        [{ text: 'SIN INTERRUPCIONES', color: 'blue' }]
      ],
      subtitle: 'Muevete mas sin miedo a quedarte sin presupuesto y recargas en plena ruta.',
      bullets: [],
      showCta: false,
      caption: 'Conecta mas viajes por hora con el plan para socios.',
      sceneShift: 12,
      copyAlign: 'left'
    },
    {
      id: 'share-and-save',
      headline: [
        [{ text: 'COMPARTE', color: 'blue' }],
        [{ text: 'EL 100% DE TUS GB', color: 'blue' }],
        [{ text: 'WHATSAPP INCLUIDO EN UN SOLO PLAN', color: 'red' }],
        [{ text: 'PARA TODOS TUS EQUIPOS', color: 'red' }]
      ],
      subtitle: 'Comparte conexion con tu copiloto, celular de repuesto o segundo equipo.',
      bullets: [
        'Con tu segundo telefono',
        'Con tu familia',
        'Con tu copiloto',
        'Emergencias sin recargar'
      ],
      showCta: false,
      caption: 'Beneficio exclusivo para socios Yango.',
      sceneShift: 24,
      copyAlign: 'right',
      showPartnerLogos: true
    }
  ];

  protected openPortabilityModal(): void {
    this.isPortabilityModalOpen = true;
  }

  protected closePortabilityModal(): void {
    this.isPortabilityModalOpen = false;
  }

  protected openWhatsApp(): void {
    window.open(this.whatsappUrl, '_blank', 'noopener,noreferrer');
  }

  protected setHero(index: number): void {
    this.activeHeroIndex = index;
  }

  protected prevHero(): void {
    const last = this.heroSlides.length - 1;
    this.activeHeroIndex = this.activeHeroIndex === 0 ? last : this.activeHeroIndex - 1;
  }

  protected nextHero(): void {
    const last = this.heroSlides.length - 1;
    this.activeHeroIndex = this.activeHeroIndex === last ? 0 : this.activeHeroIndex + 1;
  }

  protected get activeHero(): HeroSlide {
    return this.heroSlides[this.activeHeroIndex];
  }

  protected get heroSceneTransform(): string {
    return `translateX(-${this.activeHero.sceneShift}%)`;
  }

  protected get isFirstHero(): boolean {
    return this.activeHeroIndex === 0;
  }

  protected get isLastHero(): boolean {
    return this.activeHeroIndex === this.heroSlides.length - 1;
  }
}
